import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import FeeSelect from './FeeSelect';
import DecimalsSelect from './DecimalsSelect';
import RateInfo from './RateInfo';
import RateDate from './RateDate';


const CalculatorConfigForm = props => (
  <div className="Content-wrapper Content-wrapper--configbar">
    <div className="content">
      <Grid container spacing={16}>
        <Grid item xs={6} md={3}>
          <FeeSelect value={props.fee} onChange={props.updateFee} />
        </Grid>

        <Grid item xs={6} md={3}>
          <DecimalsSelect value={props.decimals} onChange={props.updateDecimals} />
        </Grid>

        <Grid item xs={6} md={3}>
          <RateDate value={props.rateDate} onChange={props.updateRateDate} />
        </Grid>

        <Grid item xs={6} md={3}>
          <RateInfo value={props.rate} />
        </Grid>
      </Grid>
    </div>
  </div>
);

CalculatorConfigForm.propTypes = {
  fee: PropTypes.number.isRequired,
  updateFee: PropTypes.func.isRequired,
  decimals: PropTypes.number.isRequired,
  updateDecimals: PropTypes.func.isRequired,
  rateDate: PropTypes.instanceOf(Date).isRequired,
  updateRateDate: PropTypes.func.isRequired,
  rate: PropTypes.number.isRequired,
};

export default CalculatorConfigForm;



// WEBPACK FOOTER //
// ./src/components/calculator/CalculatorConfigForm.js